import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';

interface AlertDialogProps extends Omit<DialogProps, 'title'> {
  open: boolean;
  onClose?: () => void;
  title?: React.ReactNode;
  desc?: React.ReactNode;
  onOk?: () => void;
  onCancel?: () => void;
  okBtnText?: string;
  cancelBtnText?: string;
  showCancelButton?: boolean;
  isDisabledOk?: boolean;
}
export default function AlertDialog({
  open,
  cancelBtnText = 'Cancel',
  desc = 'You are going to alter the data',
  okBtnText = 'Ok',
  onCancel,
  onClose,
  onOk,
  title = 'Are you sure?',
  showCancelButton = true,
  isDisabledOk = false,
  ...rest
}: AlertDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        component: 'form',
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          onOk?.();
        },
      }}
      {...rest}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {desc}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {showCancelButton && (
          <Button color="primary" variant="outlined" onClick={onCancel}>
            {cancelBtnText}
          </Button>
        )}
        <Button
          color="primary"
          disabled={isDisabledOk}
          variant="contained"
          type="submit"
          autoFocus
        >
          {okBtnText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
